import { render } from "./subusers.view.vue?vue&type=template&id=476958a0"
import script from "./subusers.view.vue?vue&type=script&lang=js"
export * from "./subusers.view.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/ssd2/projects/techno2_remaster/client_ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__